export default {
    ACTION_LOG: "Журнал действий",
    SYSTEM_ACCESS: "Доступ к системе",
    ADMIN_ACTIONS: "Действия администратора",
    USER_ACTIONS: "Действия пользователя",
    EXPORT: "Экспортировать данные"
};
